var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, Chip, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import { ArrowRight02Icon, Audit02Icon } from 'hugeicons-react';
import useTranslate from '../../../../localization/helpers';
import { useState } from 'react';
import { useGetConversationsListQuery } from '../../../../application/features/chat/chat-api';
import { AppConsts } from '../../../../application/common/constants/app-consts';
import SortDrawer from '../../../components/sort-drawer';
import AuditCardChip from './audit-chips';
var AuditCards = function (_a) {
    var openSortDrawer = _a.openSortDrawer, setOpenSortDrawer = _a.setOpenSortDrawer, audits = _a.audits, conversationFilters = _a.conversationFilters, setConversationFilters = _a.setConversationFilters, onViewAudit = _a.onViewAudit;
    var theme = useTheme();
    var _b = useTranslate(), translate = _b.translate, tWithField = _b.tWithField;
    var isscreen600900Landscape = useMediaQuery('(min-width:600px) and (max-width:900px) and (orientation: landscape)');
    var _c = __read(useState(conversationFilters.sortField), 2), sortField = _c[0], setSortField = _c[1];
    var _d = __read(useState(conversationFilters.sortDirection), 2), sortDirection = _d[0], setSortDirection = _d[1];
    var _e = useGetConversationsListQuery(conversationFilters, {
        refetchOnMountOrArgChange: true
    }), sortedAuditConverations = _e.data, isFetching = _e.isFetching;
    var sortOptions = [
        { value: 'conversationName', label: translate('audit.sortOptions.title') },
        { value: 'date', label: translate('audit.sortOptions.date') },
        { value: 'chatSource', label: translate('audit.sortOptions.chatSource') },
        { value: 'status', label: translate('audit.sortOptions.status') }
    ];
    var getChipColor = function (status) {
        switch (status) {
            case 'Active':
                return 'primary';
            case 'Not Completed':
                return 'error';
            case 'Closed':
                return 'default';
            default:
                return 'default';
        }
    };
    var translateStatus = function (status) {
        switch (status) {
            case 'Active':
                return translate('audit.active');
            case 'Not Completed':
                return translate('audit.notCompleted');
            case 'Closed':
                return translate('audit.completed');
            default:
                return status;
        }
    };
    var handleLoadMore = function () {
        if ((sortedAuditConverations === null || sortedAuditConverations === void 0 ? void 0 : sortedAuditConverations.totalCount) &&
            conversationFilters.pageSize < sortedAuditConverations.totalCount) {
            setConversationFilters(function (prev) { return (__assign(__assign({}, prev), { pageSize: prev.pageSize + AppConsts.DEFAULT_PAGE_SIZE })); });
        }
    };
    return (_jsx(_Fragment, { children: _jsxs(Box, { position: 'relative', display: 'flex', flexDirection: 'column', gap: 2, sx: {
                overflowY: 'auto',
                maxHeight: isscreen600900Landscape ? 'calc(100svh - 288px)' : 'calc(100svh - 308px)'
            }, children: [!isFetching && ((sortedAuditConverations === null || sortedAuditConverations === void 0 ? void 0 : sortedAuditConverations.items.length) === 0 || audits.length === 0) && (_jsxs(Box, { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', py: isscreen600900Landscape ? 0 : 8, px: 2, textAlign: 'center', children: [_jsx(Audit02Icon, { width: isscreen600900Landscape ? 32 : 48, height: isscreen600900Landscape ? 32 : 48, color: theme.palette.text.disabled }), _jsx(Typography, { variant: 'h6', color: 'text.secondary', mt: 0.5, children: tWithField('validations.notFound', 'common.audit') })] })), !isFetching &&
                    ((sortedAuditConverations === null || sortedAuditConverations === void 0 ? void 0 : sortedAuditConverations.items) || audits).map(function (audit) {
                        return (_jsxs(Box, { sx: {
                                p: '8px 12px 16px 12px',
                                boxShadow: theme.customShadows.z8,
                                border: "2px solid ".concat('rgba(255, 255, 255, 1)'),
                                borderRadius: theme.spacing(2),
                                backgroundColor: theme.palette.background.paper,
                                transition: 'border-color 0.3s ease'
                            }, children: [_jsxs(Box, { display: 'flex', justifyContent: 'space-between', alignItems: 'center', children: [_jsx(Typography, { variant: 'caption', color: theme.palette.text.tertiary, sx: {
                                                maxWidth: '80%',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                            }, children: "by ".concat(audit.chatBy) }), _jsx(Box, { display: 'flex', alignItems: 'center', children: _jsx(IconButton, { size: 'small', color: 'primary', onClick: function (e) {
                                                    e.stopPropagation();
                                                    onViewAudit(audit);
                                                }, children: _jsx(ArrowRight02Icon, {}) }) })] }), _jsxs(Box, { display: 'flex', flexDirection: 'column', gap: 1, children: [_jsx(Typography, { variant: 'body1', sx: {
                                                maxWidth: '80%',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                            }, children: audit.conversationName }), _jsxs(Box, { display: 'flex', justifyContent: 'space-between', alignItems: 'center', children: [_jsx(Typography, { variant: 'body2', color: theme.palette.text.secondary, sx: {
                                                        maxWidth: '80%',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap'
                                                    }, children: audit.machineName }), _jsx(Chip, { label: translateStatus(audit.status), color: getChipColor(audit.status), variant: 'soft', size: 'medium' })] }), _jsxs(Box, { display: 'flex', flexDirection: 'row', justifyContent: 'space-between', children: [_jsxs(Box, { display: 'flex', gap: 0.5, children: [_jsx(Typography, { variant: 'caption', color: theme.palette.text.tertiary, sx: {
                                                                maxWidth: '80%',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap'
                                                            }, children: new Date(audit.date).toLocaleDateString(translate('common.dateLanguageCode1'), {
                                                                year: 'numeric',
                                                                month: 'short',
                                                                day: 'numeric'
                                                            }) }), _jsx(Typography, { variant: 'caption', color: theme.palette.text.tertiary, sx: {
                                                                maxWidth: '80%',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap'
                                                            }, children: new Date(audit.date).toLocaleTimeString(translate('common.dateLanguageCode2'), {
                                                                hour: '2-digit',
                                                                minute: '2-digit',
                                                                hour12: true
                                                            }) })] }), _jsx(AuditCardChip, { label: [
                                                        String(audit.responses.liked),
                                                        String(audit.responses.disliked),
                                                        String(audit.responses.resolved)
                                                    ] })] })] }), _jsx(SortDrawer, { open: openSortDrawer, onClose: function () { return setOpenSortDrawer(false); }, sortDirection: sortDirection, setSortDirection: setSortDirection, sortField: sortField, setSortField: setSortField, sortOptions: sortOptions, onApply: function () {
                                        var updatedFilters = __assign(__assign({}, conversationFilters), { sortDirection: sortDirection, sortField: sortField, page: AppConsts.DEFAULT_PAGE_NUMBER });
                                        setConversationFilters(updatedFilters);
                                        setOpenSortDrawer(false);
                                    }, backdropColor: 'rgba(22, 28, 36, 0.1)' })] }, audit.conversationId));
                    }), sortedAuditConverations &&
                    (sortedAuditConverations === null || sortedAuditConverations === void 0 ? void 0 : sortedAuditConverations.totalCount) > 0 &&
                    conversationFilters &&
                    conversationFilters.pageSize < sortedAuditConverations.totalCount &&
                    !(sortedAuditConverations.totalCount -
                        conversationFilters.page * conversationFilters.pageSize <
                        0) && (_jsx(Button, { variant: 'outlined', fullWidth: true, onClick: handleLoadMore, disabled: isFetching, children: isFetching
                        ? translate('common.loading')
                        : translate('common.loadMore', {
                            count: sortedAuditConverations.totalCount -
                                conversationFilters.page * conversationFilters.pageSize
                        }) }))] }) }));
};
export default AuditCards;
